import { ReactNode,FC, PropsWithChildren, Dispatch, SetStateAction, ReactElement } from "react"

export type PopupContextType = {
     children:ReactNode;
}

export type SnackBarType = {
    open:boolean;
    message:string;
    duration?:number;
    variant: "success" | "error" | "warning" | "info" | undefined;
    origin?:{vertical:"top"|"bottom",horizontal:"center"|"left"|"right"}
    direction?:"up" | "down" | "left" | "right";
    onClose?:()=>void
}

export type SnackBarProviderType = {
    showSnackbar:(details:SnackBarType)=>void;
    CustomModal:FC<PropsWithChildren<{ children: ReactNode,title?:string | ReactElement,open:boolean,setOpen:Dispatch<SetStateAction<boolean>>,handleClose?:Function }>>;
    // handleModal:(open:boolean)=>void;
}

export const defaultContextValue: SnackBarProviderType = {
    showSnackbar: () => {},
    CustomModal: ({ children }) => <>{children}</>,
    // handleModal: () => {}
  };